import Vue from 'vue'
import Timeline from './Timeline.vue'

Vue.component(Timeline.name, Timeline)

export default Timeline
